import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon";

class ErrorView extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "chat-view",
      className: "error-view"
    }, /*#__PURE__*/React.createElement("span", {
      className: "oops-something-went-wrong"
    }, "Oops, something went wrong"), /*#__PURE__*/React.createElement("div", {
      className: "sad-cardboard"
    }, /*#__PURE__*/React.createElement(ChatIcon, {
      className: "large"
    })), /*#__PURE__*/React.createElement("div", {
      className: "try-again"
    }, /*#__PURE__*/React.createElement("span", null, "Please check your internet connection and try again"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      className: "try-again-button",
      onClick: this.props.onTryAgainClick
    }, "Try Again"))));
  }

}

ErrorView.propTypes = {
  onTryAgainClick: PropTypes.func
};
export default ErrorView;